import { defineComponent as _defineComponent } from 'vue'

import { userConfig } from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'page-number',
  props: ['page', 'count'],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const __returned__ = { props, get userConfig() { return userConfig } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})